/* src/app/private/components/packages/package-list/package-list.component.scss */
/*# sourceMappingURL=package-list.component.css.map */
